// extracted by mini-css-extract-plugin
export default {"tx":"dd57d618f0","line":"f561e84700"};